import React from "react";
import { Rise, WordsRise } from "./Reveal";
import { useLang } from "../../lib/LangContext";

export default function Manifesto() {
  const { dict } = useLang();
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 border-t hairline"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-20 md:mb-28">
          <div className="col-span-12 md:col-span-3 flex items-start">
            <span className="label text-[#1A1918]">{dict.manifesto_kicker}</span>
          </div>
          <h2 className="col-span-12 md:col-span-9 serif font-light tracking-[-0.02em] leading-[1] text-4xl md:text-6xl lg:text-7xl max-w-[24ch] text-[#1A1918]">
            <WordsRise text={dict.manifesto_title} />
          </h2>
        </div>

        <div className="flex flex-col">
          {dict.manifesto_chapters.map((m, i) => (
            <Rise key={m.n} delay={i * 0.05}>
              <article
                data-testid={`manifesto-chapter-${i}`}
                className="grid grid-cols-12 gap-6 py-10 md:py-14 border-t hairline items-start"
              >
                <div className="col-span-3 md:col-span-2 serif italic text-4xl md:text-5xl text-[#B56B45]">
                  {m.n}
                </div>
                <h3 className="col-span-9 md:col-span-5 serif font-light text-2xl md:text-4xl leading-[1.1] tracking-tight text-[#1A1918]">
                  {m.title}
                </h3>
                <p className="col-span-12 md:col-span-5 text-[15px] md:text-[16px] leading-[1.7] text-[#5C5A55] max-w-[46ch]">
                  {m.body}
                </p>
              </article>
            </Rise>
          ))}
          <div className="border-t hairline" />
        </div>
      </div>
    </section>
  );
}
